import { render, staticRenderFns } from "./RepairList.vue?vue&type=template&id=28cb08b8&scoped=true"
import script from "./RepairList.vue?vue&type=script&lang=js"
export * from "./RepairList.vue?vue&type=script&lang=js"
import style0 from "./RepairList.vue?vue&type=style&index=0&id=28cb08b8&prod&scoped=true&lang=css"
import style1 from "./RepairList.vue?vue&type=style&index=1&id=28cb08b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cb08b8",
  null
  
)

export default component.exports